import { render } from "./FormItemDetailing.vue?vue&type=template&id=aeb4f288&scoped=true"
import script from "./FormItemDetailing.vue?vue&type=script&lang=js"
export * from "./FormItemDetailing.vue?vue&type=script&lang=js"

import "./FormItemDetailing.vue?vue&type=style&index=0&id=aeb4f288&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeb4f288"]])

export default __exports__